import { useTranslation } from 'react-i18next'
import useContacts from '@hooks/useContacts'
import Section from '@components/Section'
import { Link } from 'react-router-dom'

import { sendInviteMoreClickedEvent } from '@/services/analytics/gtm'
import Button from '@components/Button'

export default function ParticipationStatus() {
  const { contacts, contactGoal, isLoading, error } = useContacts()
  const { t } = useTranslation()

  if (error) {
    return <div>Error: {(error as Error).message}</div>
  }
  if (isLoading) {
    return (
      <Section wrapperStyle='bg-cta mx-2 my-8 py-8 px-4 md:px-2 !border-none !rounded-lg' rounded>
        <div>Loading...</div>
      </Section>
    )
  }

  if (contacts) {
    const invitationCount = contacts.length

    const count = contactGoal - contacts.length

    if (count > 0) {
      return (
        <Section wrapperStyle='bg-sunshine-yellow my-8 py-8 px-4 md:px-2 !border-none !mx-0'>
          <div className=' text-neutral-800 font-serif text-center flex flex-col gap-y-4'>
            <div className='text-3xl font-serif'>{t('content.components.progress_cta.incomplete.title')}</div>
            <div className='text'>
              {t('content.components.progress_cta.incomplete.counter_text')}
              <span className='pl-4 text-3xl'>{invitationCount}</span> of{' '}
              <span className='pl-0.5 text-3xl'>{contactGoal}</span>
            </div>
            <div className='font-sans text-light mt-2 mb-2'>
              {t('content.components.progress_cta.incomplete.message', { count })}
            </div>
            <div className='mx-auto w-full sm:w-2/3 md:w-1/2 '>
              <Link to='../invite'>
                <Button
                  label={t('content.components.progress_cta.incomplete.cta_text')}
                  variant='alt'
                  fullwidth
                  onClick={() => sendInviteMoreClickedEvent('participation_status_component')}
                />
              </Link>
            </div>
          </div>
        </Section>
      )
    } else {
      return (
        <Section wrapperStyle='bg-leaf-green my-8 py-8 px-4 md:px-2 !border-none !mx-0'>
          <div className=' text-alt font-serif text-center flex flex-col gap-y-4'>
            <div className='text-3xl font-serif'>{t('content.components.progress_cta.complete.title')}</div>
            <div className='text'>
              {t('content.components.progress_cta.incomplete.counter_text')}
              <span className='pl-4 text-3xl'>{invitationCount}</span> of{' '}
              <span className='pl-0.5 text-3xl'>{contactGoal}</span>
            </div>
            <div className='text-gray-800 font-sans text-light mt-2 mb-2'>
              {t('content.components.progress_cta.complete.message')}
            </div>
            <div className='mx-auto w-full sm:w-2/3 md:w-1/2 '>
              <Link to='../invite'>
                <Button
                  label={t('content.components.progress_cta.complete.cta_text')}
                  variant='alt'
                  fullwidth
                  onClick={() => sendInviteMoreClickedEvent('participation_status_component')}
                />
              </Link>
            </div>
          </div>
        </Section>
      )
    }
  }
}
